import { PLCustomerData, PLCustomerGender } from 'types/plCustomerData';

import {
	CustomerActionTypes,
	RESET_CUSTOMER,
	SET_CUSTOMER,
	SET_CUSTOMER_EXTRA_INFORMATION,
	SET_CUSTOMER_IS_MEMBER,
} from '../actions/customerActionTypes';

export const initialState: PLCustomerData = {
	initials: '',
	lastName: '',
	lastNamePrefix: '',
	gender: 'UNKNOWN' as PLCustomerGender,
	birthdate: '',
	postalCode: '',
	street: '',
	houseNumber: '',
	houseNumberSuffix: '',
	city: '',
	phoneNumber: '',
	email: '',
	isMember: undefined,
	extraInformation: {
		phoneNumber: '',
		email: '',
		birthdate: '',
	},
};
const customer = (
	state: PLCustomerData = initialState,
	action: CustomerActionTypes
): PLCustomerData | null => {
	switch (action.type) {
		case SET_CUSTOMER:
			return action.payload;
		case RESET_CUSTOMER:
			return initialState;
		case SET_CUSTOMER_EXTRA_INFORMATION:
			return { ...state, extraInformation: action.payload };
		case SET_CUSTOMER_IS_MEMBER:
			return { ...state, isMember: action.payload };
		default:
			return state;
	}
};

export default customer;
